// extracted by mini-css-extract-plugin
module.exports = {"grid":"PBNSLX","home_intro":"Vhxw5S"};